import axios from '@/utils/fetch';

const url = '/api/package';

// 获取用途
export function getPurpose(params: any) {
  return axios.get(`${url}/purpose`, { params });
}
